import React from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Leftbar from '../Components/Sidebar/Leftbar'
import AdminCommentsList from '../Components/Course/AdminCommentsList'

function AdminCommentsPage() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          marginLeft: 24,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <SHeaderbar />
        <div style={{ flex: 1, padding: '24px', minHeight: 0, overflow: 'auto' }}>
          <AdminCommentsList />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default AdminCommentsPage

